module.exports = __webpack_public_path__ + "img/farming_31.88946c5b.png";